import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Signup = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch(`/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          password,
          adminuserid: window.APPSETTING.adminuserid 
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Signup failed');
      }

      navigate('/login');
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div className="section">
      <div className="container" style={{ display: 'flex', justifyContent: 'center' }}>
        <div className="c-form" style={{ width: '100%', maxWidth: '400px' }}>
          <form onSubmit={handleSubmit}>
            {error && (

              <div style={{
                color: '#d93025', 
                backgroundColor: '#fce8e6', 
                padding: '10px', 
                borderRadius: '4px', 
                marginBottom: '15px',
                fontSize: '13px'
              }}>
                {error}
              </div>
            )}
            
            <div className="fg">
              <label>Email</label>
              <input 
                type="email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                required 
                placeholder="name@firm.com"
              />
            </div>
            
            <div className="fg">
              <label>Password</label>
              <input 
                type="password" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required 
                placeholder="••••••••"
              />
            </div>
            
            <button type="submit" className="btn btn-dark" style={{ width: '100%', marginTop: '10px' }}>
              Register
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Signup;